// --- React ---
import { useState } from "react";
import { useNavigate } from "react-router-dom";

// --- Components ---
import { notify } from "../../../common/notificationService";
import { useLookupParameter } from "../../../utils/get-lookup";

// --- Models ---

// --- Services ---
import stationParameterSvc from "../../../services/api/stationParameter";
import { StationParameterItem } from "../../../models/types/stationParameter";

interface FormProps {
  stationId: number | string;
  data: StationParameterItem[];
  onSuccess: () => void;
}

export default function StationParameter({ stationId, data, onSuccess }: FormProps) {
  const navigate = useNavigate();
  const { lookupParameter } = useLookupParameter();

  const [loading, setLoading] = useState({
    isLoading: false,
    index: -1
  });

  const [comfirmDelete, setComfirmDelete] = useState({
    isOpen: false,
    index: -1,
  });

  const createStationParameter = async (index: number, stationId: number | string, parameterId: number) => {
    setLoading({
      isLoading: true,
      index: index
    });
    try {
      const res = await stationParameterSvc.createStationParameter({
        stationId,
        parameterId
      });
      if (res.content.status) {
        notify("Thành công", "Thêm thành công", "success");
        onSuccess();
      }
    } catch (error) {
      notify("Lỗi", "Xảy ra lỗi", "danger");
    } finally {
      setLoading({
        isLoading: false,
        index: -1
      });
    }
  };

  const deleteStationParameter = async (index: number, id: number | string) => {
    setLoading({
      isLoading: true,
      index: index
    });
    try {
      const res = await stationParameterSvc.deleteStationParameter(id);
      if (res.content.status) {
        onSuccess();
      }
    } catch (error) {
      notify("Lỗi", "Xảy ra lỗi", "danger");
    } finally {
      setLoading({
        isLoading: false,
        index: -1
      });
    }
  };

  const handleValueChange = (checked: boolean, index: number, newValue: any) => {
    console.log(checked, index, newValue);
    if (checked) {
      createStationParameter(index, stationId, newValue.value);
    } else {
      deleteStationParameter(index, newValue.id);
    }
  };

  return (
    <>
      <div className="w-full h-full">
        <div className="grid 2xl:grid-cols-3 lg:grid-cols-2 md:grid-cols-1 gap-3">
          {lookupParameter.map((item, index) => {
            const parameter = data.find(p => p.parameterId === item.value);
            console.log('parameter', parameter);
            return (
              <div key={index} className="bg-white border border-gray-200 shadow">
                <div className="flex">
                  <div className="p-2 flex justify-center items-center">
                    <input
                      id={item.value}
                      type="checkbox"
                      checked={parameter ? true : false}
                      disabled={loading.isLoading && loading.index === index}
                      onChange={(e) => handleValueChange(e.target.checked, index, parameter ? parameter : item)}
                    />
                    <label htmlFor={item.value} className="flex justify-center items-center cursor-pointer">
                      <div className="border-l border-gray-200 px-2 ml-2">
                        <span className="text-gray-500">Mã: </span>
                        <span className="font-semibold text-green-700">{item.code}</span>
                      </div>
                      <div className="border-l border-gray-200 px-2">
                        <span className="text-gray-500">Tên: </span>
                        <span className="font-semibold text-blue-700">{item.name}</span>
                      </div>
                      <div className="border-l border-gray-200 px-2">
                        <span className="text-gray-500">Đơn vị: </span>
                        <span className="font-semibold text-red-700">{item.unitName ? item.unitName : "-"}</span>
                      </div>
                    </label>
                  </div>

                </div>
              </div>
            )
          })}
        </div>
      </div>
    </>
  );
}